/** @jsx jsx */
import { jsx } from '@emotion/react';
import { colors, effects, transitions } from '../../theme';

export const IconButton = ({ icon, ...props }) => {
  return (
    <div
      {...props}
      css={{
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '3px',
        outline: 'none',
        backgroundColor: colors.background,
        borderRadius: '50%',
        cursor: 'pointer',
        textShadow: effects.glow.textShadow,
        '&:hover': {
          textShadow: effects.glow.textShadow,
          svg: {
            fill: props.hoverFill,
            stroke: props.hoverStroke
          }
        },
        svg: {
          transition: transitions.hover,
          fill: props.fill,
          stroke: colors.font
        }
      }}
      role="button"
      tabIndex={0}
    >
      {/* not defining color as a workaround to use css styling instead */}
      {icon.render({ color: '', size: 23 })}
    </div>
  );
};
